var _path, _path2, _path3, _path4, _path5, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEndpointKit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 62 38",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 28.25H25V29.75H55V28.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.75H61C61.1989 37.7499 61.3896 37.6709 61.5303 37.5303C61.6709 37.3896 61.7499 37.1989 61.75 37V21C61.7499 20.8011 61.6709 20.6104 61.5303 20.4697C61.3896 20.3291 61.1989 20.2501 61 20.25H1C0.801104 20.2501 0.610369 20.3291 0.469728 20.4697C0.329088 20.6104 0.250053 20.8011 0.25 21V37C0.250053 37.1989 0.329088 37.3896 0.469728 37.5303C0.610369 37.6709 0.801104 37.7499 1 37.75ZM1.75 21.75H60.25V36.25H1.75V21.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 30C7.55228 30 8 29.5523 8 29C8 28.4477 7.55228 28 7 28C6.44772 28 6 28.4477 6 29C6 29.5523 6.44772 30 7 30Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 30C13.5523 30 14 29.5523 14 29C14 28.4477 13.5523 28 13 28C12.4477 28 12 28.4477 12 29C12 29.5523 12.4477 30 13 30Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 30C19.5523 30 20 29.5523 20 29C20 28.4477 19.5523 28 19 28C18.4477 28 18 28.4477 18 29C18 29.5523 18.4477 30 19 30Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: -4.37114e-8,
    x2: 11,
    y2: 21,
    stroke: "currentColor",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: -4.37114e-8,
    x2: 52,
    y2: 21,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEndpointKit);
export default __webpack_public_path__ + "static/media/icon_endpoint_kit.5cfbe6e3c384b910516a7e019befe695.svg";
export { ForwardRef as ReactComponent };